<template>
  <layout-content>
    <notification-list />
  </layout-content>
</template>

<script>
  import NotificationList from '@notify/components/notifications/notifications-table';
  import { mapActions } from 'vuex';

  export default {
    components: {
      NotificationList
    },
    created() {
      this.readAllServer();
    },
    methods: {
      ...mapActions('notify/notifications/table', ['readAllServer'])
    }
  };
</script>
